import Enlang from './entries/en-US';
import Hindi from './entries/hi-Hindi';

const AppLocale = {
  en: Enlang,
  hi: Hindi,
};

export default AppLocale;
